import MuiPhoneNumber from 'material-ui-phone-number';
import { FormControl } from '@material-ui/core';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      "& .MuiInputBase-input": {
        height: 'inherit',
      },
      "& .MuiInputLabel-outlined": {
        transform: 'translate(14px, 18px) scale(1)'
      },
      "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
        transform: "translate(14px, -6px) scale(0.75)"
      },      
      "& .MuiInputBase-root": {
        height: '48px',        
        fontSize: "1.4rem",
        [theme.breakpoints.up('xl')]: {
          fontSize: "1.6rem",
        },
      },
      "& .MuiInputLabel-root": {
        fontSize: "1.4rem",
        [theme.breakpoints.up('xl')]: {
          fontSize: "1.6rem",
        },
      },
      "& .MuiOutlinedInput-input": {
        padding: '16.5px 14px',
      },
      "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
        fontSize: "1.4rem",
        [theme.breakpoints.up('xl')]: {
          fontSize: "1.6rem",
        },
      },
      "& .MuiFormHelperText-root": {
        fontSize: "1.2rem",
        [theme.breakpoints.up('xl')]: {
          fontSize: "1.4rem",
        },
      },
    },
}));

type SelectFieldTypes = {
  value?: string | number,
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
  onBlur?: () => void,
  variant?: 'outlined' | 'filled' | 'standard',
  id?: string,
  label?: string,
  error: any,
  helperText: string | false | undefined,
  name: string,
  fullWidth?: boolean,
  required?: boolean,
  type?: string | undefined,
}


export const PhoneInput = ({
  value, onChange, onBlur, variant = "outlined", id,
  label, error, helperText, name,
  fullWidth = false, required = false, type = 'text' }: SelectFieldTypes) => {
  const classes = useStyles();

  return (
    <FormControl variant={variant} fullWidth={fullWidth}>
      <MuiPhoneNumber
        defaultCountry={'br'}
        type={type}
        className={classes.root}
        id={id}
        name={name}
        label={label}
        value={value}
        error={error}
        helperText={helperText}
        onChange={onChange}
        onBlur={onBlur}
        variant="outlined"
        required={required}
       />
    </FormControl>
  )
}